import { contextZoneId } from "domains/canvas/components/sections/AIPanel/contextZone";
import { resizeGuideId } from "domains/canvas/components/sections/ResizePanel/resizeGuideId";
import type { PolotnoElement } from "domains/canvas/interfaces";
import { ElementType } from "polotno/model/group-model";

import { maskImageId } from "../sections/AIPanel/maskImageId";

import { toolVisibleElements } from "./toolVisibleElements";

export const getIsToolVisibleElement = (element: PolotnoElement) =>
  toolVisibleElements.includes(element.id);

export const scenarioElements = [
  contextZoneId,
  maskImageId,
  resizeGuideId,
  "loading-image",
];

export function getIsUserElement(element: PolotnoElement | ElementType) {
  return (
    !scenarioElements.includes(element.id) &&
    element.type !== "drawing-overlay" &&
    element.type !== "resize-guide"
  );
}
